import { useEffect, useState } from "react";

type Toast = { id: number; message: string };
let nextId = 1;

/** Show a dismissable error toast from anywhere (incl. non-React code) */
export function showErrorToast(message: string) {
  window.dispatchEvent(new CustomEvent("app:error-toast", { detail: message }));
}

export function ErrorToaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const onToast = (e: Event) => {
      const message = (e as CustomEvent<string>).detail || "Something went wrong.";
      const id = nextId++;
      setToasts((t) => [...t.slice(-2), { id, message }]);
      setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 6000);
    };
    window.addEventListener("app:error-toast", onToast);
    return () => window.removeEventListener("app:error-toast", onToast);
  }, []);

  if (toasts.length === 0) return null;
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 items-center px-4 w-full max-w-md pointer-events-none"
      role="alert"
      aria-live="assertive"
    >
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => setToasts((all) => all.filter((x) => x.id !== t.id))}
          className="px-4 py-2.5 text-xs font-semibold rounded-lg shadow-lg text-center pointer-events-auto"
          style={{
            background: "rgba(155, 44, 56, 0.95)",
            color: "#fff",
            backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}
